import axios from 'axios';
import searchBox from '../../common/search-box/search-box';
import Multiselect from 'vue-multiselect';
import {mapState} from 'vuex';
import {SEARCH_URL, SUGGEST_URL} from '../../common/utils/api';

const PAGE_SIZE = 10;
const MIN_QUERY_LENGTH = 3;

export default {
	data() {
		return {
			currentLangCode: null,
			showHeaderSearch: false,
			suggestions: [], // searchbox miatt
			queryParamName: 'query',
			query: '',
			megamenuLeaveTimeout: 0,
			portfolioStock: null
		}
	},
	components: {
		'search-box': searchBox,
		'multiselect': Multiselect
	},
	created() {
		axios.get('/apps/portfolio-stock')
		.then(response => {
			this.portfolioStock = response.data;

			const change = parseInt(this.portfolioStock.change);
			if (change == 0) {
				this.portfolioStock.changeDir = 'unchanged';
			} else if (change < 0) {
				this.portfolioStock.changeDir = 'desc';
			} else if (change > 0) {
				this.portfolioStock.changeDir = 'asc';
			}
		})
		.catch(e => console.error('Nem sikerült lekérdezni a részvényárfolyamot.', e));
	},
	computed: {
		...mapState('headerSearchStore', ['hideHeaderSearchMenu'])
	},
	methods: {
		toggleDesktopMenu(event) {
			let desktopMenuElement = event.currentTarget.querySelector('.header-desktop__megamenu');
			this.showHeaderSearch = false;

			if (desktopMenuElement && !desktopMenuElement.contains(event.target)) {
				if (!desktopMenuElement.classList.contains('header-desktop__megamenu--open')) {
					this.closeAllMenu('header-desktop__megamenu--open');
					desktopMenuElement.classList.add('header-desktop__megamenu--open');
				} else {
					desktopMenuElement.classList.remove('header-desktop__megamenu--open');
				}
			}
		},
		toggleMobileMenu(event) {
			let mobileMenuElement = event.currentTarget.closest('.header-mobile__menu-item');

			if (!mobileMenuElement.classList.contains('header-mobile__menu-item--open')) {
				mobileMenuElement.classList.add('header-mobile__menu-item--open');
			} else {
				mobileMenuElement.classList.remove('header-mobile__menu-item--open');
			}
		},
		toggleHamburgerMenu() {
			let hamburgerMenuElement = document.querySelector('.header-mobile__menubar');
			this.showHeaderSearch = false;

			if (!hamburgerMenuElement.classList.contains('header-mobile__menubar--open')) {
				hamburgerMenuElement.classList.add('header-mobile__menubar--open');
			} else {
				hamburgerMenuElement.classList.remove('header-mobile__menubar--open');
			}
		},
		closeAllMenu(selector) {
			let allOpenMenuElement = document.querySelectorAll(`.${selector}`);

			allOpenMenuElement.forEach(menu => {
				menu.classList.remove(selector);
			});
		},
		handleClickOutside(event) {
			if (!event.target.closest('.header-desktop__menu-item')) {
				this.closeAllMenu('header-desktop__megamenu--open');
			}
		},
		toggleHeaderSearch() {
			let previousHeaderSearch = this.showHeaderSearch;
			this.closeAllMenu('header-desktop__megamenu--open');
			this.closeAllMenu('header-mobile__menubar--open');
			this.closeAllMenu('header-mobile__menu-item--open');
			this.showHeaderSearch = !previousHeaderSearch;
		},
		goToUrl(option) {
			window.location.href = option.url;
		},
		search(query, page = 0) {
			this.query = query;
			if (query && query.length >= MIN_QUERY_LENGTH) {
				Axios.get(SEARCH_URL, {
					params: {
						query,
						from: page * PAGE_SIZE,
						size: PAGE_SIZE,
						lang: window.lang
					}
				}).then((response) => {
					this.searchResults = response.data.hits;
					this.currentPage = Math.ceil(response.data.from / PAGE_SIZE);
					this.numberOfPages = Math.ceil(response.data.total / response.data.size);
					this.numberOfSearchResults = response.data.total;
					this.isLoading = false;
					this.searchedAtLeastOnce = true;
					this.hitsOnPage = response.data.size;
				}).catch((error) => {
					this.isLoading = false;
				});
			}
		},
		isActive(path) {
			if (path[0] !== '/') path = '/' + path;
			path = location.protocol+'//'+location.host + path;
			return path.replace(/\?.*/g, '') === location.href.replace(/\?.*/g, '');

		},
		autoSuggest(query) {
			if (query && query.length >= MIN_QUERY_LENGTH) {
				Axios.get(SUGGEST_URL, {
					params: {
						query: query,
						lang: window.lang
					}
				}).then((response) => {
					this.suggestions = response.data.suggestions;
					this.isLoading = false;
				}).catch((error) => {
					this.isLoading = false;
				});
			} else {
				this.suggestions = [];
			}
		} // search-box miatt
	}
}



// WEBPACK FOOTER //
// ../source/modules/HEA01-header/HEA01-header.js